import {defineMessages} from 'react-intl';

export default defineMessages({
  profile: {
    id: 'Myaccount.ReactNavigation.Label.profile',
    defaultMessage: 'Profile',
  },
  orders: {
    id: 'Myaccount.ReactNavigation.Label.orders',
    defaultMessage: 'Orders',
  },
  listings: {
    id: 'Myaccount.ReactNavigation.Label.listings',
    defaultMessage: 'Listings',
  },
  sales: {
    id: 'Myaccount.ReactNavigation.Label.sales',
    defaultMessage: 'Sales',
  },
  payments: {
    id: 'Myaccount.ReactNavigation.Label.payments',
    defaultMessage: 'Payments',
  },
  activity: {
    id: 'Myaccount.ReactNavigation.Label.activity',
    defaultMessage: 'Activity',
  },
  friends: {
    id: 'Myaccount.ReactNavigation.Label.friends',
    defaultMessage: 'Friends',
  },
  favorites: {
    id: 'Myaccount.ReactNavigation.Label.favorites',
    defaultMessage: 'Favorites',
  },
  giftCodes: {
    id: 'Myaccount.ReactNavigation.Label.giftCodes',
    defaultMessage: 'StubHub Wallet',
  },
  promoCodes: {
    id: 'Myaccount.ReactNavigation.Label.promoCodes',
    defaultMessage: 'Promo Codes',
  },
  settings: {
    id: 'Myaccount.ReactNavigation.Label.settings',
    defaultMessage: 'Settings',
  },
  sellerPayments: {
    id: 'Myaccount.ReactNavigation.Label.payments.sellerPayments',
    defaultMessage: 'Payout methods',
  },
  buyerPayments: {
    id: 'Myaccount.ReactNavigation.Label.payments.buyerPayments',
    defaultMessage: 'Payment methods',
  },
  payoutHistory: {
    id: 'Myaccount.ReactNavigation.Label.payments.payoutHistory',
    defaultMessage: 'Payout history',
  },
});
